import account from './account'
import alerts from './alerts'
import alt from './alt'
import brand from './brand'
import buttons from './buttons'
import chat from './chat'
import chatCommands from './chatCommands'
import chatImages from './chatImages'
import dates from './dates'
import dialogs from './dialogs'
import error from './error'
import feedback from './feedback'
import friends from './friends'
import header from './header'
import home from './home'
import login from './login'
import mail from './mail'
import members from './members'
import menu from './menu'
import messages from './messages'
import mfcShare from './mfcShare'
import missMFC from './missMFC'
import modelBrowser from './modelBrowser'
import modelsYouMayLike from './modelsYouMayLike'
import modelTile from './modelTile'
import nav from './nav'
import news from './news'
import rooms from './rooms'
import search from './search'
import settings from './settings'
import signup from './signup'
import system from './system'
import tags from './tags'
import tokens from './tokens'
import userBroadcast from './userBroadcast'
import userStatus from './userStatus'
import videoAvatars from './videoAvatars'

export const locales = {
    account,
    alerts,
    alt,
    brand,
    buttons,
    chat,
    chatCommands,
    chatImages,
    dates,
    dialogs,
    error,
    feedback,
    friends,
    header,
    home,
    login,
    mail,
    members,
    menu,
    messages,
    mfcShare,
    missMFC,
    modelBrowser,
    modelsYouMayLike,
    modelTile,
    nav,
    news,
    rooms,
    search,
    settings,
    signup,
    system,
    tags,
    tokens,
    userBroadcast,
    userStatus,
    videoAvatars,
}

export default locales
